export default import.meta.ROLLDOWN_FILE_URL__7SPQDqRdwtnKaclwn8Q4A